<template>
    <div class="step-a-wrapper">
        
        <div><h3 class="mb-20" style="color: #1890ff;">Section 5: Suggestions</h3></div>
    <a-form layout="vertical" :form="formStepE">
            <!-- Q30 Satisfaction with Curriculum -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">30. How satisfied are you with the university curriculum ?</span> 
                </template>
                <a-radio-group 
                    v-model="form.curriculumSatisfaction"
                    v-decorator="[
                        'form.curriculumSatisfaction',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                >
                    <a-radio value="1">Very Dissatisfied</a-radio>
                    <a-radio value="2">Dissatisfied</a-radio>
                    <a-radio value="3">Neutral</a-radio>
                    <a-radio value="4">Satisfied</a-radio>
                    <a-radio value="5">Very Satisfied</a-radio>
                </a-radio-group>
            </a-form-item>

            <!-- Q31 Courses to Promote -->

            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">31. What courses at Mahidol University should be promoted to help contribute to your career ?</span> 
                </template>

                <a-checkbox-group 
                    v-model="form.promotedCourses"
                    v-decorator="[
                        'form.promotedCourses',
                        {
                        initialValue: form.promotedCourses,
                        rules: [
                            { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                        ]
                        }
                    ]"
                >
                    <a-row :gutter="[16,16]">
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="English Language">(1) English Language</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Computer">(1) Computer</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Accounting">(1) Accounting</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Internet">(1) Internet</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Job Training">(1) Job Training</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Research Methodology">(1) Research Methodology</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Chinese Language">(1) Chinese Language</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Languages in ASEAN">(1) Languages in ASEAN</a-checkbox></a-col>
                        <a-col :sm="24" :xs="24" :md="12"><a-checkbox value="Others">(1) Others</a-checkbox></a-col>
                    </a-row>
                    <a-input class="mt-5" v-if="form.promotedCourses.includes('Others')" v-model="form.promotedCoursesOther" />
                </a-checkbox-group>
            </a-form-item>

            <!-- Q32 Curriculum Feedback -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">32. The appropriate changes to the course in which you graduated, that could help you with your future career ?</span> 
                </template>
                <a-textarea 
                    v-model="form.necessaryClasses"
                    v-decorator="[
                        'form.necessaryClasses',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    rows="2" 
                    placeholder="Classes that you think are necessary for the course"
                />
                <a-textarea 
                    v-model="form.improvedClasses"
                    v-decorator="[
                        'form.improvedClasses',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    rows="2" 
                    placeholder="Classes that you think need to be improved"
                />
                <a-textarea v-model="form.unnecessaryClasses"
                    v-decorator="[
                        'form.unnecessaryClasses',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    placeholder="Classes that you think are not necessary for the course" 
                    rows="2" 
                />
                <a-textarea 
                    v-model="form.addedClasses"
                    v-decorator="[
                        'form.addedClasses',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    placeholder="Classes that you think need to be added to the course" 
                    rows="2" 
                />
                <a-textarea 
                    v-model="form.courseStrength" 
                    v-decorator="[
                        'form.courseStrength',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    placeholder="The strength of the course" 
                    rows="2" 
                />
                <a-textarea 
                    v-model="form.courseWeakness"
                    v-decorator="[
                        'form.courseWeakness',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]" 
                    placeholder="Any weaknesses (please specify)" 
                    rows="2" 
                />
            </a-form-item>

            <!-- Q33-35 Suggestions -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">33. Suggestions regarding course and field of study ?</span> 
                </template>
                <a-textarea 
                    v-model="form.suggestionCourse" 
                    v-decorator="[
                        'form.suggestionCourse',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]" 
                    rows="3" 
                />
            </a-form-item>
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">34. Suggestions regarding teaching ?</span> 
                </template>
                <a-textarea 
                    v-model="form.suggestionTeaching" 
                    v-decorator="[
                        'form.suggestionTeaching',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]" 
                    rows="3" 
                />
            </a-form-item>
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">35. Suggestions regarding student development activities ?</span> 
                </template>
                <a-textarea 
                    v-model="form.suggestionStudentDev" 
                    v-decorator="[
                        'form.suggestionStudentDev',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]" 
                    rows="3" 
                />
            </a-form-item>

            <!-- Q36 Satisfaction with Alumni Communication -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">36. How satisfied are you with Mahidol University's communication with alumni ?</span> 
                </template>
                <a-radio-group 
                    v-model="form.alumniCommunicationSatisfaction"
                    v-decorator="[
                        'form.institutionType',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                >
                    <a-radio value="1">Very Satisfied</a-radio>
                    <a-radio value="2">Satisfied</a-radio>
                    <a-radio value="3">Unsure</a-radio>
                    <a-radio value="4">Dissatisfied</a-radio>
                    <a-radio value="5">Very Dissatisfied</a-radio>
                </a-radio-group>
            </a-form-item>

            <!-- Q37-41 Additional Feedback -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">37. Do you have a suggestion about Mahidol University's communication with alumni ?</span> 
                </template>
                <a-textarea 
                    v-model="form.suggestionAlumniComm" 
                    v-decorator="[
                        'form.suggestionAlumniComm',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                    rows="3" 
                />
            </a-form-item>
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">38. What are your expectations from Mahidol University ?</span> 
                </template>
                <a-textarea 
                    v-model="form.expectationMahidol" 
                    rows="3" 
                    v-decorator="[
                        'form.expectationMahidol',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                />
            </a-form-item>
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">39. What makes you feel engaged with Mahidol University ?</span> 
                </template>
                <a-textarea 
                    v-model="form.engagementMahidol" 
                    rows="3" 
                    v-decorator="[
                        'form.engagementMahidol',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                />
            </a-form-item>
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">40. What events from Mahidol University do you look forward to attending ?</span> 
                </template>
                <a-checkbox-group 
                    v-model="form.preferredEvents"

                >
                    <a-checkbox value="1">Homecoming event for Mahidol University alumni</a-checkbox>
                    <br />
                    <a-checkbox value="2">Mahidol University Academic Conference</a-checkbox>
                    <br />
                    <a-checkbox value="4">Charity events organized by Mahidol University, such as golf tournaments,
                        bowling, etc.</a-checkbox>
                    <br />
                    <a-checkbox value="0">
                        Others: <a-textarea v-model="form.eventOther" style="display: block; margin-top: 8px;"
                            rows="3" />
                    </a-checkbox>
                </a-checkbox-group>
            </a-form-item>

            <!-- Q41 Email Subscription -->
            <a-form-item>
                <template slot="label">
                    <span class="font-web font-weight-bold" style="">41. Please give us your email if you consider subscribing to Mahidol University's email newsletter ?</span> 
                </template>
                <a-input 
                    v-model="form.subscriptionEmail" 
                    type="email" 
                    v-decorator="[
                        'form.subscriptionEmail',
                        { rules: [{ required: true, message: 'Please input' }] },
                    ]"
                />
            </a-form-item>

        </a-form>

        <div class="text-right">
            <a-button-group>
                <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
                <a-button @click="submitAndValidateE" type="primary"> Go forward<a-icon type="right" /> </a-button>
            </a-button-group>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            formStepE: this.$form.createForm(this, { name: 'stepE' }),
            form: {
                curriculumSatisfaction: '',
                promotedCourses: [],
                promotedCoursesOther: '',
                necessaryClasses: '',
                improvedClasses: '',
                unnecessaryClasses: '',
                addedClasses: '',
                courseStrength: '',
                courseWeakness: '',
                suggestionCourse: '',
                suggestionTeaching: '',
                suggestionStudentDev: '',
                alumniCommunicationSatisfaction: '',
                suggestionAlumniComm: '',
                expectationMahidol: '',
                engagementMahidol: '',
                preferredEvents: [],
                eventOther: '',
                subscriptionEmail: ''
            }
        };
    },
    mounted() {},
    methods: {
        backSection() {
            this.$emit('backSection')
        },
        submitAndValidateE() {
            this.formStepE.validateFields((err, values) => {
                if (!err) {
                    this.$emit('updateData', 'stepE', { ...this.form, ...values.form });
                    this.$emit('NextSectionSubmit');
                }
            });
        },
    },
};
</script>

<style scoped>
.step-a-wrapper {
    padding: 20px;
}
</style>
